import domReady from "@wordpress/dom-ready";
import { render, useState } from "@wordpress/element";
import { nanoid } from "nanoid";

const App = ({ attributes }) => {
  const { features, buttonText, buttonUrl, enableButton, target } = attributes;
  const [active, setActive] = useState({
    ...features[0],
  });

  const targetBlank = (
    <>
      {target === true && (
        <a href={buttonUrl} target="">
          {buttonText}
        </a>
      )}
    </>
  );

  return (
    <div className="flywp-blocks-customer-feature">
      <div className="tabs-click">
        <ul>
          {features.map((feature) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            <li
              key={nanoid()}
              className={feature.id === active.id ? "active" : ""}
              onClick={() =>
                setActive({
                  ...feature,
                })
              }
            >
              <span>
                <img
                  src={feature.preview}
                  alt={feature.title}
                  width={feature.previewWidth}
                  loading="lazy"
                />
              </span>
              {feature.title}
            </li>
          ))}
        </ul>
      </div>

      <div className="tabs-content">
        <div className="tabs-content-text">
          <h3>{active.tabSubTitle}</h3>
          <p
            dangerouslySetInnerHTML={{
              __html: active.description,
            }}
          ></p>
        </div>
        {enableButton && (
          <div className="button-wrap">
            {target === true ? (
              <a href={buttonUrl} target="_blank">
                {buttonText}
              </a>
            ) : (
              <a href={buttonUrl}>{buttonText}</a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

domReady(() => {
  const blockId = document.getElementById("flywp-blocks-imagine-tab");
  const blockAttributes = blockId.getAttribute("data-block-attributes");
  render(<App attributes={JSON.parse(blockAttributes)} />, blockId);
});
